import React, { FunctionComponent, useContext } from 'react';
import styles from './DarkModeSwitch.module.scss';
import { FormControlLabel, FormGroup, Switch } from '@material-ui/core';
import { constants, getFromLocalStorage } from 'app/utils/localStorage';
import { DarkModeContext } from 'app/context/DarkModeContext';
import { DarkModeIcon, LightModeIcon } from 'app/assets/images/icons';

interface Props {}

const DarkModeSwitch: FunctionComponent<Props> = ({}) => {
  const isDark = getFromLocalStorage(constants.darkMode);

  const { darkMode, darkToggle } = useContext<any>(DarkModeContext);
  return (
    <div className={styles.DarkModeSwitch}>
      <FormGroup className={styles.DarkModeSwitch__Button}>
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
        <FormControlLabel
          control={<Switch defaultChecked={darkMode} />}
          label=""
          onChange={() => {
            darkToggle();
          }}
          color="primary"
        />
      </FormGroup>
    </div>
  );
};

export default DarkModeSwitch;
